import React from "react";
import MainLayout from "../../MainLayout.tsx";
import TextImageGrid from "../../../components/grids/textImageGrid.component.tsx";
import colors from "../../../constants/colors.ts";
import ClientInfo from "../../../components/media/clientInfo.component.tsx";
import { imagesFoldersTypes } from "../../../constants/app.constants.ts";

const Section4: React.FC = () => {
  return (
    <MainLayout>
      <TextImageGrid
        icon={'Upper-Commas-Grey'}
        iconVariant={imagesFoldersTypes.ELEMENTS}
        backgroundColor={colors.BLUE_0067F6}
        image={'James-Appleseed-Image'}
        imageVariant={imagesFoldersTypes.TEST_IMAGES}
        alignImage={"center"}
        title={
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. "
        }
        titleColor={colors.WHITE}
        text={
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        }
        textColor={colors.BLUE_B4DBFF}
      >
        <ClientInfo
          icon={'James-Appleseed-Avatar'}
          opacity={0.8}
          name="James Appleseed"
          role="CEO, Pineapple Inc."
          alignItems="flex-start"
        />
      </TextImageGrid>
    </MainLayout>
  );
};

export default Section4;
